var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('t-orm-fields-content',_vm._g(_vm._b({attrs:{"ctx":_vm.ctx,"items":_vm.items,"context":_vm.context}},'t-orm-fields-content',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }